import { useAppSelector } from '../../store/slice';
import { ftuxSelectors } from '../../store/slice/Ftux';


export const useFtuxHighlight = (targetId: string, ftuxId?: string): boolean => {
	const isFtuxActive = useAppSelector(ftuxSelectors.isRunning);
	const activeFtuxId = useAppSelector(ftuxSelectors.getActiveFtuxId);
	const currentTarget = useAppSelector(ftuxSelectors.getCurrentTarget);

	// If FTUX is not running, don't highlight
	if (!isFtuxActive) {
		return false;
	}

	// If a specific FTUX ID is required, check it matches
	if (ftuxId && activeFtuxId !== ftuxId) {
		return false;
	}

	// Check if this element is the current target
	return currentTarget === targetId;
};

